import { Turbo } from "@hotwired/turbo-rails"
Turbo.start()

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);

// Import Stimulus controllers
import "./i18n";
import { Application } from "@hotwired/stimulus";
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers";

// Initialize Stimulus application
const application = Application.start();
const context = require.context("controllers", true, /\.js$/);
application.load(definitionsFromContext(context));

require("trix")
require("@rails/actiontext")
import "trix/dist/trix.css"

// Initialize Mixpanel browser SDK once
import Mixpanel, { initMixpanel } from "components/Lib/mixpanel";
initMixpanel();
